function initSlider() {
  $('#product-grid').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }

const products_on_page = document.getElementById('product-grid');
let best_seller_url = document.getElementById("bestseller-hidden").value;


async function getBestSellers() {
  try {
    let res = await fetch(best_seller_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function initBestSellers() {
  let nextPage = await getBestSellers();

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');


  const productgrid = nextPageDoc.getElementById('product-grid');
  const new_products = productgrid.querySelectorAll('li.grid__item');
  const new_url = productgrid.dataset.nextUrl;

  for (let i = 0; i < new_products.length; i++) {
    products_on_page.appendChild(new_products[i]);
  }
  initSlider();
}
initBestSellers();